// Consultation type configuration
export const CONSULTATION_TYPE_CONFIG: Record<
  string,
  {
    value: string;
    label: string;
    name: string;
    placeholder: string;
    queries: readonly { label: string; value: string }[];
  }
> = {
  'define-project': {
    value: 'define-project',
    label:
      "Quelles sont les idées que possède le bénéficiaire quant à son projet – ce qu'il veut ou ne veut plus par exemple",
    name: 'Définir un projet d’évolution professionnelle',
    placeholder: 'Décrivez les idées, envies et refus du bénéficiaire concernant son projet...',
    queries: [
      { label: 'Lister les métiers', value: 'list-jobs' },
      { label: 'Explorer les 5 scénarios d’évolution', value: 'explore-evolution-scenarios' },
      { label: 'Réaliser une analyse SWOT', value: 'swot-analysis' },
      { label: 'Réaliser une étude de faisabilité', value: 'feasibility-study' },
    ],
  },
  'skills-training': {
    value: 'skills-training',
    label: "Décrire en quelques mots le projet d'évolution professionnelle du bénéficiaire",
    name: 'Évaluer ses compétences - se former',
    placeholder: "Veuillez décrire le projet d'évolution professionnelle",
    queries: [
      {
        label: 'Identifier les compétences transférables et à acquérir',
        value: 'transferable-skills',
      },
      { label: 'Trouver des formations pour s’améliorer', value: 'find-training' },
      { label: 'Détecter les aides financières mobilisables', value: 'financial-aid' },
      { label: 'Lister les ressources d’apprentissage', value: 'learning-resources' },
    ],
  },
  'job-search': {
    value: 'job-search',
    label: "Quels sont les types d'emploi que la personne recherche et sur zone géographique ?",
    name: 'Rechercher un emploi',
    placeholder: "Précisez les types d'emploi recherchés et la zone géographique...",
    queries: [
      { label: 'Analyser le CV du bénéficiaire', value: 'cv-analysis' },
      { label: 'Trouver des offres d’emploi', value: 'job-offers' },
      { label: 'Rédiger une lettre de motivation', value: 'cover-letter' },
      { label: 'Créer une séquence de préparation à un entretien', value: 'interview-preparation' },
    ],
  },
  'create-business': {
    value: 'create-business',
    label: "Notez les idées qui ont déjà été données par le bénéficiaire au cours de l'entretien",
    name: 'Créer son entreprise',
    placeholder: "Notez les idées entrepreneuriales évoquées lors de l'entretien...",
    queries: [
      { label: 'Proposer idées de création d’entreprise', value: 'business-ideas' },
      { label: 'Trouver des concepts de franchise', value: 'franchise-concepts' },
      {
        label: "Lister les financements d'aide à la création d'entreprise",
        value: 'startup-financing',
      },
      {
        label: 'Établir un plan d’action pour préparer un business plan',
        value: 'business-plan-action',
      },
    ],
  },
} as const;

export const CONSULTATION_TYPE_DEFAULT_CONFIG = {
  label: "Décrire en quelques mots le projet d'évolution professionnelle du bénéficiaire",
  placeholder: "Veuillez décrire le projet d'évolution professionnelle",
  queries: [],
};
